import { shadows } from "@/theme";
import { convertPxToRem } from "@/utils";
import { Stack } from "@mui/material";
import ButtonWithAnalytics from "../ButtonWithAnalytics";
import { useTranslation } from "react-i18next";
import { AnalyticsLinkIntent } from "@/services/analytics-adapter";

interface BottomFixedCallToActionProps {
  buttonText: string;
  onButtonClick: () => void;
  ariaLabel: string;
  analyticsPageName: string;
  isButtonEnabled?: boolean;
  analyticsButtonIntent?: AnalyticsLinkIntent;
  buttonVariant?: "outlined" | "contained" | "text";
  buttonColor?:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
}

export default function BottomFixedCallToAction({
  buttonText,
  onButtonClick,
  ariaLabel,
  analyticsPageName,
  isButtonEnabled = true,
  analyticsButtonIntent = "confirmational",
  buttonVariant = "contained",
  buttonColor = "primary",
}: BottomFixedCallToActionProps) {
  const { t } = useTranslation();
  return (
    <Stack
      position="fixed"
      display="flex"
      flexDirection="row"
      component="article"
      aria-label={t(`${ariaLabel}` as any)}
      sx={{
        width: "100%",
        left: 0,
        bottom: 0,
        backgroundColor: "background.paper",
        boxShadow: shadows.heavy,
        alignItems: "center",
        padding: 2,
        paddingBottom: "calc(16px + env(safe-area-inset-bottom, 0px))",
        borderTopLeftRadius: convertPxToRem(16),
        borderTopRightRadius: convertPxToRem(16),
        zIndex: 2,
      }}
    >
      <ButtonWithAnalytics
        page={analyticsPageName}
        text={t(`${buttonText}` as any)}
        intent={analyticsButtonIntent}
        onClick={onButtonClick}
        color={buttonColor}
        variant={buttonVariant}
        fullWidth
        disabled={!isButtonEnabled}
      >
        {t(`${buttonText}` as any)}
      </ButtonWithAnalytics>
    </Stack>
  );
}
